/**
 * Copyright 2018-present MongoDB, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

enum RedirectFragmentFields {
  StitchError = "_stitch_error",
  State = "_stitch_state",
  UserAuth = "_stitch_ua",
  LinkUser = "_stitch_link_user",
  StitchLink = "_stitch_link",
  ClientAppId = "_stitch_client_app_id"
}

export default RedirectFragmentFields;
